<template>
    <div class="part-container">
      <!-- 头部 -->
      <div class="part-header">
        <div class="header-title  ">相关资讯</div>
        <div class="header-more " @click="handleMore"><span class="plus">+</span>&nbsp;&nbsp;更多</div>
      </div>
  
      <!-- Swiper 内容 -->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(slide, slideIndex) in swiperSlides" :key="slideIndex">
            <div class="slide-content">
              <div
                v-for="(item, index) in slide"
                :key="index"
                class="part-item"
                @click="handleItemClick(item)"
              >
                  <!-- <img src="/assets/~/media/images/ai/zixun-icon.png" alt="活动icon" class="item-icon"> -->
                  <div class="item-info">
                      <div class="item-title">{{ item.title }}</div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </template>
  
  <script>
  import Swiper from "swiper";
  export default {
    name: 'DetailList',
    props: {
      // 头部标题
      title: {
        type: String,
        required: true,
      },
      // 数据列表
      list: {
        type: Array,
        default: () => [],
      },
      // 最大显示数量
      maxItems: {
        type: Number,
        default: 12,
      },
      // 是否展开状态
      isExpanded: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        swiper: null,
      };
    },
    computed: {
      // 是否显示展开按钮
      showExpandButton() {
        return this.list.length > 1;
      },
      // 每页显示的数据条数
      itemsPerSlide() {
        return this.isExpanded ? 5 : 3;
      },
      // 将数据分组为 Swiper 的 slides
      swiperSlides() {
        const slides = [];
        const itemsPerSlide = this.itemsPerSlide;
        
        for (let i = 0; i < this.list.length; i += itemsPerSlide) {
          slides.push(this.list.slice(i, i + itemsPerSlide));
        }
        
        // 确保只显示3页
        return slides.slice(0, 3);
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.initSwiper();
      });
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
    },
    watch: {
      isExpanded() {
        this.$nextTick(() => {
          this.reinitSwiper();
        });
      },
      list: {
        handler() {
          this.$nextTick(() => {
            this.reinitSwiper();
          });
        },
        deep: true
      }
    },
    methods: {
      // 初始化 Swiper
      initSwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }
        
        this.swiper = new Swiper('.swiper-container', {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          resizeObserver: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          preloadImages: true,
          updateOnImagesReady: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        });
      },
      
      // 重新初始化 Swiper
      reinitSwiper() {
        this.initSwiper();
      },
      
      // 处理条目点击
      handleItemClick(item) {
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), 'question-Details-多模态-相关资讯： '+ item.title, 1]);
        stm_clicki("send",'event',window.location.href, "点击", 'question-Details-多模态-相关资讯： '+ item.title);
        if (item.url) {
          //打开新网页链接
          window.open(item.url);
        }
      },
      
      // 处理更多按钮点击
      handleMore() {
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), 'question-Details-多模态-相关资讯-更多', 1]);
        stm_clicki("send",'event',window.location.href, "点击", 'question-Details-多模态-相关资讯-更多');
        // 触发父组件事件
        this.$emit('more-click','zixun');
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import './style/part.css';
  .part-header {
    width: calc((373 / 413) * 100%);
    margin: calc((20 / 413) * 100%) auto calc((12 / 413) * 100%) auto;
    padding: 0;
  }
  .part-container {
    height: 100%;
    flex-direction: column;
    display: flex;
  }
  .header-more {
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }
  .header-more .plus {
    font-size: calc((18 / 1920) * 100vw); /* 加号稍微大一点 */
    display: inline-block;
    transform: translateY(calc((0 / 1920) * 100vw)); /* 微调视觉对齐 */
  }
  .header-more {
     background-color:#CDD0D251// rgba(255, 255, 255, 0.2);
  }
  .header-more:hover {
    background-color: #CDD0D277//rgba(255, 255, 255, 0.3);
  }
  
  /* Swiper 容器样式 */
  .swiper-container {
    width: calc((373 / 413) * 100%);
    margin: 0 auto;
    // height: auto;
  }
  
  .swiper-wrapper {
    height: auto;
  }
  
  .swiper-slide {
    height: auto;
  }
  
  .slide-content {
    width: 100%;
  }
  
  /* 分页器样式 */
  .swiper-pagination {
    // position: relative;
    // margin-top: calc((20 / 1920) * 100vw);
    text-align: center; 
    margin-bottom: calc((20 / 1920) * 100vw);
  }
  ::v-deep .swiper-pagination-bullets {

  }
  ::v-deep .swiper-pagination-bullet {
    width: calc((10 / 1920) * 100vw);
    height: calc((10 / 1920) * 100vw);
    background-color: rgba(255, 255, 255, 0.2);
    opacity: 1;
    margin: 0 calc((2 / 1920) * 100vw);
  }
  
  ::v-deep .swiper-pagination-bullet-active {
    background-color: #fff;
  }
  .part-item:hover {
    background-color: rgba(249, 250, 251, 0.8);
  }
  .part-item {
    width: 100%; /* 宽度为100% */
    height: calc((93 / 1920) * 100vw);
    // aspect-ratio: 373 / 93; /* 高度和宽度之比为 93:373 */
    background-color: #ffffff;//rgba(249, 250, 251, 1);
    overflow: hidden;
    border-radius: calc((12 / 1920) * 100vw);
    padding: calc((16 / 413) * 100%) 0;
    display: flex;
    align-items: center;
    gap: calc((20 / 413) * 100%);
    margin-bottom: calc((15 / 413) * 100%);
    .item-icon {
      //  height: 100%;
      height: calc((93 / 1920) * 100vw - calc((32 / 1920) * 100vw));
      width: calc((93 / 1920) * 100vw - calc((32 / 1920) * 100vw));
        object-fit: contain;
        margin-left: calc((16 / 413) * 100%);
    }
    .item-info {
        height: 100%;
        padding-right: calc((20 / 413) * 100%);
        //padding: calc((7 / 413) * 100%) calc((20 / 413) * 100%) calc((7 / 413) * 100%) 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
         margin-left:  calc((20 / 413) * 100%);
    }
    .item-title {
        font-size: calc((16 / 1920) * 100vw);
        font-family: 'FZLanTingHeiS-B-GB';
        margin: 0;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-word;
           color: #000;//#fff;
    }
    .item-content {
        font-size: calc((14 / 1920) * 100vw);
        font-family: 'FZLanTingHeiS-R-GB';
           color: #000;//#fff;
    }
  }
  </style>
  